import { render, staticRenderFns } from "./CandidateAcceptModal.vue?vue&type=template&id=00c68ba2&lang=pug"
import script from "./CandidateAcceptModal.vue?vue&type=script&lang=js"
export * from "./CandidateAcceptModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports